import { useStaticQuery, graphql } from 'gatsby'

export const useInfoPagesData = () => {
  const { allFile } = useStaticQuery(
    graphql`
      query {
        allFile(
          filter: { sourceInstanceName: { eq: "info" } }
          sort: { fields: childMdx___frontmatter___order }
        ) {
          nodes {
            childMdx {
              id
              slug
              frontmatter {
                title
                shortTitle
                description
                excludeOnFooter
                listedOnBuyPage
              }
            }
          }
        }
      }
    `
  )
  return allFile.nodes
}

export const pageLinks = (infoPagesData, currentSlug) => [
  ...infoPagesData.map(({ childMdx: page }) => {
    return {
      to: `/info/${page.slug}/`,
      isCurrent: currentSlug && page.slug === currentSlug,
      label: page.frontmatter.title,
      shortLabel: page.frontmatter.shortTitle ?? page.frontmatter.title,
      excludeOnFooter: page.frontmatter.excludeOnFooter,
      listedOnBuyPage: page.frontmatter.listedOnBuyPage,
    }
  }),
  {
    href: 'https://justboil.github.io/docs/',
    label: 'Docs',
    shortLabel: 'Docs',
    excludeOnFooter: false,
    listedOnBuyPage: true,
  },
]
